import { render, staticRenderFns } from "./account-menu-mobile.component.vue?vue&type=template&id=2f9f7916&scoped=true"
import script from "./account-menu-mobile.component.vue?vue&type=script&lang=js"
export * from "./account-menu-mobile.component.vue?vue&type=script&lang=js"
import style0 from "./account-menu-mobile.component.vue?vue&type=style&index=0&id=2f9f7916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9f7916",
  null
  
)

export default component.exports